import { PROFESSIONS_PATH, SCHOOLS_PATH } from "../../../../../constants/RoutesConstants";

import H5 from "../../../ui/Typography/Headings/H5";
import Paper from "../../../ui/Paper";
import Props from "./props";
import React from "react";
import useHistoryPush from "../../../../../hooks/useHistoryPush";

const Card: React.FC<Props> = ({ id, name, title, description, categories, type, onClick }) => {
    const push = useHistoryPush(`${type === "profession" ? PROFESSIONS_PATH : SCHOOLS_PATH}/${name}/${id}`);
    return (
        <Paper
            onClick={() => {
                push();
                if (onClick) {
                    onClick();
                }
            }}
        >
            <H5>{title}</H5>
            <div dangerouslySetInnerHTML={{ __html: description }} />
            <i>
                <strong>Categorie</strong>: {categories}
            </i>
        </Paper>
    );
};

export default Card;
